var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.979,
    height: 25.755,
    viewBox: "0 0 25.979 25.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M14.825,23.635A43.019,43.019,0,0,1,1.118,9.928,7.319,7.319,0,0,1,2.136.874L2.3.715a2.357,2.357,0,0,1,3.641.318L9.176,5.657a2.385,2.385,0,0,1-.265,3.057l-.2.2a1.8,1.8,0,0,0-.289,2.2,14.93,14.93,0,0,0,5.213,5.214,1.8,1.8,0,0,0,2.2-.289l.2-.2a2.385,2.385,0,0,1,3.057-.265l4.624,3.239a2.357,2.357,0,0,1,.318,3.641l-.16.158a7.315,7.315,0,0,1-9.053,1.02Zm6.968-13.608a7.069,7.069,0,0,0-7.068-7.069,1.473,1.473,0,1,1,0-2.945A10.013,10.013,0,0,1,24.738,10.028a1.473,1.473,0,0,1-2.945,0Zm-5.3,0A1.767,1.767,0,0,0,14.725,8.26a1.473,1.473,0,1,1,0-2.945,4.712,4.712,0,0,1,4.711,4.713,1.472,1.472,0,0,1-2.944,0Z",
    transform: "translate(0.724 0.502)",
    fill: "#9e9e9e",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.164d1807edb9ed24fe98f6cd4309a385.svg";
export { ForwardRef as ReactComponent };